import * as React from 'react';
import { GrProjects, GrGroup } from "react-icons/gr";
import { IoClose, IoChevronDown, IoCloseCircle } from "react-icons/io5";
import { toast } from 'react-toastify';
import { addNewProject, getAllMembers, getAllTeams, logout } from '../../../service/service-call';

const inputClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition-colors focus:border-[#262673] focus:ring-2 focus:ring-[#262673]/10";
const labelClass = "mb-1.5 block text-xs font-semibold text-gray-500";

export default function AddProjects({ addProjectsModal }) {
  const [allTeams, setAllTeams] = React.useState([]);
  const [allMembers, setAllMembers] = React.useState([]);
  const [tname, setTName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [projectId, setProjectId] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState("");
  const [selectedTeams, setSelectedTeams] = React.useState([]);
  const [selectedTeamIds, setSelectedTeamIds] = React.useState([]);
  const [tags, setTags] = React.useState([]);
  const [tagInput, setTagInput] = React.useState("");
  const [tagError, setTagError] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  const [teamOpen, setTeamOpen] = React.useState(false);
  const [teamSearch, setTeamSearch] = React.useState("");
  const teamRef = React.useRef(null);

  React.useEffect(() => {
    getAllTeam();
    getAllMemberForProject();
  }, []);

  React.useEffect(() => {
    function handleClickOutside(e) {
      if (teamRef.current && !teamRef.current.contains(e.target)) setTeamOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function getAllTeam() {
    getAllTeams("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllTeams(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  function getAllMemberForProject() {
    getAllMembers("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllMembers(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  const handleProjectNameChange = (e) => setTName(e.target.value);
  const handleProjectDescChange = (e) => setDescription(e.target.value);

  const teamOptions = allTeams.map((option) => option.teamName);
  const filteredTeamOptions = teamOptions
    .filter((o) => !selectedTeams.includes(o))
    .filter((o) => o.toLowerCase().includes(teamSearch.toLowerCase()));

  function addTeam(name) {
    setSelectedTeams((prev) => [...prev, name]);
    setTeamSearch("");
  }

  function removeTeam(name) {
    setSelectedTeams((prev) => prev.filter((t) => t !== name));
  }

  const validateTagValue = (value) => {
    if (tags.length >= 3) {
      setTagError("Maximum 3 tags allowed");
      return false;
    }
    if (value.length > 6) {
      setTagError("Tag length should be less than 6");
      return false;
    }
    setTagError("");
    return true;
  };

  function handleTagKeyDown(e) {
    if ((e.key === "Enter" || e.key === ",") && tagInput.trim()) {
      e.preventDefault();
      const value = tagInput.trim();
      if (validateTagValue(value)) {
        setTags((prev) => [...prev, value]);
        setTagInput("");
      }
    } else if (e.key === "Backspace" && !tagInput && tags.length > 0) {
      setTags((prev) => prev.slice(0, -1));
    }
  }

  function removeTag(idx) {
    setTags((prev) => prev.filter((_, i) => i !== idx));
    setTagError("");
  }

  function addNewProjects() {
    let arr = [];
    selectedTeams.map(r => {
      let d = allTeams.find(e => e.teamName === r);
      arr.push(d.id);
    });

    if (tname === "" || tname === undefined || description === "" || description === undefined) {
      toast.error('Fields cannot be blank');
      return false;
    } else if (tags === "" || tags === undefined || tags.length === 0) {
      toast.error('Tags cannot be blank');
      return false;
    } else if (arr === "" || arr === undefined || arr.length === 0) {
      toast.error('At least one team must be selected');
      return false;
    } else {
      setSubmitting(true);
      addNewProject(tname, description, arr, tags).then(resp => {
        setSubmitting(false);
        toast.success('Project added successfully');
        addProjectsModal();
      }).catch(error => {
        setSubmitting(false);
        if (error && error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
          toast.error(error.response.data.errors[0]);
        } else {
          toast.error("Internal server error, contact support team");
        }
      });
    }
  }

  return (
    <div className="flex max-h-[85vh] flex-col">
      {/* Header */}
      <div className="relative border-b border-gray-100 px-6 pb-4 pt-6">
        <button
          onClick={addProjectsModal}
          className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
        >
          <IoClose size={18} />
        </button>

        <div className="flex items-center gap-3 pr-8">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50">
            <GrProjects size={20} className="text-[#0B6BCB]" />
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400">New project</p>
            <p className="text-sm font-bold text-[#0B6BCB]">Project Details</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-6 py-5">
        <div className="mb-4">
          <label className={labelClass}>
            Project Name <span className="text-red-400">*</span>
          </label>
          <input className={inputClass} type="text" maxLength={17} value={tname} onChange={handleProjectNameChange} />
          <p className="mt-1 text-right text-[10px] text-gray-300">{tname.length}/17</p>
        </div>

        <div className="mb-4">
          <label className={labelClass}>
            Description <span className="text-red-400">*</span>
          </label>
          <textarea className={inputClass} rows={3} maxLength={300} value={description} onChange={handleProjectDescChange} />
          <p className="mt-1 text-right text-[10px] text-gray-300">{description.length}/300</p>
        </div>

        {/* Teams multi-select with chips */}
        <div className="relative mb-4" ref={teamRef}>
          <label className={labelClass}>
            Add Project Teams <span className="text-red-400">*</span>
          </label>

          <div
            onClick={() => setTeamOpen(true)}
            className="flex min-h-[42px] w-full flex-wrap items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2 py-1.5 focus-within:border-[#262673] focus-within:ring-2 focus-within:ring-[#262673]/10"
          >
            {selectedTeams.map((name) => (
              <span
                key={name}
                className="flex items-center gap-1.5 rounded-full bg-[#262673]/5 py-1 pl-2.5 pr-2 text-xs font-medium text-[#262673]"
              >
                <GrGroup size={11} />
                {name}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeTeam(name);
                  }}
                  className="text-[#262673]/50 hover:text-red-500"
                >
                  <IoCloseCircle size={13} />
                </button>
              </span>
            ))}
            <input
              type="text"
              value={teamSearch}
              onChange={(e) => setTeamSearch(e.target.value)}
              onFocus={() => setTeamOpen(true)}
              placeholder={selectedTeams.length === 0 ? "Add teams..." : ""}
              className="min-w-[100px] flex-1 border-none bg-transparent py-1 text-sm text-gray-800 outline-none"
            />
            <IoChevronDown size={14} className={`shrink-0 text-gray-400 transition-transform ${teamOpen ? "rotate-180" : ""}`} />
          </div>

          {teamOpen && (
            <div className="absolute z-10 mt-1 max-h-56 w-full overflow-y-auto rounded-lg border border-gray-100 bg-white py-1 shadow-xl">
              {filteredTeamOptions.length === 0 ? (
                <p className="px-3 py-2 text-xs text-gray-400">No matching teams</p>
              ) : (
                filteredTeamOptions.map((name) => (
                  <button
                    key={name}
                    type="button"
                    onClick={() => addTeam(name)}
                    className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 transition-colors hover:bg-gray-50"
                  >
                    <GrGroup size={13} className="text-[#262673]" />
                    {name}
                  </button>
                ))
              )}
            </div>
          )}
        </div>

        {/* Tags */}
        <div>
          <label className={labelClass}>
            Tags <span className="text-red-400">*</span>
          </label>
          <div className="flex min-h-[42px] w-full flex-wrap items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2 py-1.5 focus-within:border-[#262673] focus-within:ring-2 focus-within:ring-[#262673]/10">
            {tags.map((tag, i) => (
              <span
                key={i}
                className="flex items-center gap-1.5 rounded-full bg-orange-50 py-1 pl-2.5 pr-2 text-xs font-medium text-orange-600"
              >
                {tag}
                <button
                  type="button"
                  onClick={() => removeTag(i)}
                  className="text-orange-400 hover:text-red-500"
                >
                  <IoCloseCircle size={13} />
                </button>
              </span>
            ))}
            <input
              type="text"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={handleTagKeyDown}
              placeholder={tags.length === 0 ? "Enter tags / keywords" : ""}
              className="min-w-[100px] flex-1 border-none bg-transparent py-1 text-sm text-gray-800 outline-none"
            />
          </div>
          <div className="mt-1.5 flex items-center justify-between">
            <p className="text-[10px] text-gray-300">Type a tag and press Enter</p>
            {tagError && <p className="text-[10px] font-medium text-red-500">{tagError}</p>}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-end border-t border-gray-100 px-6 py-4">
        <button
          onClick={addNewProjects}
          disabled={submitting}
          className="flex items-center gap-2 rounded-lg bg-orange-500 px-6 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {submitting && <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/40 border-t-white" />}
          Submit
        </button>
      </div>
    </div>
  );
}